import * as React from 'react';

export interface PaginationState<Entry> {
    totalPages: number;
    entries: ReadonlyArray<Entry>;
}

export default function usePagination<Entry>(
    currentPage: number,
    perPage: number,
    allEntries: ReadonlyArray<Entry>,
): PaginationState<Entry> {
    const totalPages = Math.ceil(allEntries.length / perPage);
    const entries = React.useMemo<ReadonlyArray<Entry>>(() => {
        const startIndex = Math.max(currentPage - 1, 0) * perPage;
        return allEntries.slice(startIndex, startIndex + perPage);
    }, [allEntries, currentPage, perPage]);

    return {
        totalPages,
        entries,
    };
}
